<footer>
  <div class="container">
    <section class="ft-main">
      <div class="ft-main-item">
        <h2 class="ft-title">Platform</h2>
        <ul>
          <li><a href="https://realwear.com" target="_blank">RealWear Website</a></li>
          <li><a href="https://cloud.realwear.com" target="_blank">RealWear Cloud</a></li>
          <li><a href="https://realwear.setupmyhmt.com/configure" target="_blank">Setup My Device</a></li>
        </ul>
      </div>
      <div class="ft-main-item">
        <h2 class="ft-title">Resources</h2>
        <ul>
          <li><a href="https://www.realwear.com/developer/" target="_blank">Become a Developer</a></li>
          <li><a href="https://www.realwear.com/blog/" target="_blank">News Blog</a></li>
          <li><a href="https://support.realwear.com/knowledge" target="_blank">Knowledge Base</a></li>
          <li><a href="https://developer.realwear.com" target="_blank">Developer Docs</a></li>
          <li><a href="https://changelog.realwear.com" target="_blank">Cloud Changelog</a></li>
        </ul>
      </div>
      <div class="ft-main-item">
        <h2 class="ft-title">Connect</h2>
        <ul>
          <li><a href="https://www.realwear.com/contact-us/" target="_blank">Contact Us</a></li>
          <li><a href="https://www.realwear.com/contact-us/#locations" target="_blank">Our Locations</a></li>
        </ul>
      </div>
      <div class="ft-main-item">
        <h2 class="ft-title">Stay Updated</h2>
        <ul class="social">
          <li>
            <a [routerLink]="" (click)="openSubscribeDialog()"
              ><fa-icon [icon]="faEnvelope" size="lg"></fa-icon>Subscribe to our mailing list</a
            >
          </li>
          <li>
            <a href="https://twitter.com/realwearinc" target="_blank"
              ><fa-icon [icon]="faTwitter" size="lg"></fa-icon>Follow us on Twitter</a
            >
          </li>
          <li>
            <a href="https://linkedin.com/company/realwear-inc." target="_blank"
              ><fa-icon [icon]="faLinkedin" size="lg"></fa-icon>Connect on Linkedin</a
            >
          </li>
          <li>
            <a href="https://github.com/realwear" target="_blank"
              ><fa-icon [icon]="faGithub" size="lg"></fa-icon>Get examples on Github</a
            >
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCf48qCgOXQvtVstkeM2guyw" target="_blank"
              ><fa-icon [icon]="faYoutube" size="lg"></fa-icon>View on Youtube</a
            >
          </li>
        </ul>
      </div>
    </section>

    <section class="ft-legal">
      <ul class="ft-legal-list">
        <li>
          <a href="https://www.realwear.com/legal/Cloud-license-agreement/" target="_blank">Terms &amp; Conditions</a>
        </li>
        <li><a href="https://www.realwear.com/privacy-policy/" target="_blank">Privacy Policy</a></li>
      </ul>
      <div>&copy; 2023 Copyright RealWear Inc.</div>
    </section>
  </div>
</footer>
